// ============================================
// src/features/dashboard/hooks/useHotelSelection.ts
// ============================================

import { useState, useEffect } from 'react';
import { usePermissions, useGetList } from 'react-admin';

interface Hotel {
  id: string;
  name: string;
  groupId?: string;
}

export const useHotelSelection = () => {
  const { permissions: role } = usePermissions();
  const [selectedHotelId, setSelectedHotelId] = useState<string | null>(null);
  const [availableHotels, setAvailableHotels] = useState<Hotel[]>([]);

  // Get user's assigned hotel from localStorage (for HotelAdmin/Receptionist)
  const userHotelId = localStorage.getItem('hotelId');
  const userGroupId = localStorage.getItem('groupId');

  // Fetch hotels based on role
  const { data: hotels, isLoading } = useGetList<Hotel>('hotels', {
    pagination: { page: 1, perPage: 100 },
    sort: { field: 'name', order: 'ASC' },
    filter: userGroupId && role === 'GroupAdmin' ? { groupId: userGroupId } : {},
  });

  useEffect(() => {
    if (role === 'HotelAdmin' || role === 'Receptionist') {
      // For HotelAdmin/Receptionist, use their assigned hotel
      if (userHotelId) {
        setSelectedHotelId(userHotelId);
        setAvailableHotels([]);
      }
    } else if (hotels) {
      // For SuperAdmin/GroupAdmin, show available hotels
      setAvailableHotels(hotels);
      if (hotels.length > 0 && !selectedHotelId) {
        setSelectedHotelId(hotels[0].id);
      }
    }
  }, [role, userHotelId, hotels, selectedHotelId]);

  return {
    selectedHotelId,
    setSelectedHotelId,
    availableHotels,
    canSelectHotel: role === 'SuperAdmin' || role === 'GroupAdmin',
    isLoading,
  };
};